import { render, staticRenderFns } from "./UpdateCashback.vue?vue&type=template&id=0a497443&"
import script from "./UpdateCashback.vue?vue&type=script&lang=js&"
export * from "./UpdateCashback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports